window.addEventListener('DOMContentLoaded', function() {

  
    var title = $('.synchronized-systems-banner-with-text .z-top__header');
    var titleText = title.html().replace(' ', '<br>');
    title.html(titleText);

    var synchronSection = $('.synchronized-systems-animation-banner').eq(0);
    var synchron_count = 0;

    var synchronSection2 = $('.synchronized-systems-animation-banner').eq(1);
    var synchron_count2 = 0;

    if($( window ).width() > 768 ){
        var offset = $('.topping').offset().top + 600;
    } else{
        var offset = $('.topping').offset().top + 450;
    }

    $(window).scroll(function(){
        if(synchronSection.offset().top - offset <= $(this).scrollTop() && synchron_count == 0) {
            synchron_count = 1;
            synchronAnimation(synchronSection);
        }

        if(synchronSection2.offset().top - offset <= $(this).scrollTop() && synchron_count2 == 0) {
            synchron_count2 = 1;
            synchronAnimation(synchronSection2);
        }
    });

   $('.synchronized-systems-section-slider .products_slider').slick({
      slidesToShow: 4,
      dots: true,
      responsive: [
          {
              breakpoint: 1025,
              settings: {
                  slidesToShow: 2,
                  dots: true
              }
          },
          {
              breakpoint: 569,
              settings: {
                  slidesToShow: 1,
                  dots: true
              }
          }
      ]
  });
});

$.fn.animate_Text = function() {
    var string = this.text();
    return this.each(function(){
        var $this = $(this);
        $this.html(string.replace(/./g, '<span class="new">$&</span>'));
        $this.find('span.new').each(function(i, el){
            setTimeout(function(){ $(el).addClass('div_opacity'); }, 40 * i);
        });
    });
};

function TotalLength(el){
    var path = document.querySelectorAll(el);
    for (let elem of path) {
        var len = Math.round(elem.getTotalLength() );
        elem.setAttribute("stroke-dasharray", len);
        elem.setAttribute("stroke-dashoffset", len);
        elem.classList.add('draw');
    }
};

function synchronAnimation(synchronSection){
    TotalLength('#' + synchronSection.attr('id') + ' #synchron-icon #Oval');
    TotalLength('#' + synchronSection.attr('id') + ' #synchron-icon #Path');

    synchronSection.find('.description').show();
    synchronSection.find('.description').animate_Text();

    setTimeout(function() {
        synchronSection.find('#icon .path-fill').addClass('full');
        synchronSection.find('#icon .path-fill-dark').addClass('full');
    }, 2000);

    var buttonTime = 6000;
    if (synchronSection.attr('id') == 'synchronSection1') {
        buttonTime = 9000;
    }
    setTimeout(function() {
        synchronSection.find('.button').css('opacity','1');
    }, buttonTime);
}
